import { render, staticRenderFns } from "./JobsTemplateDashboard.vue?vue&type=template&id=3b984005&scoped=true&"
import script from "./JobsTemplateDashboard.vue?vue&type=script&lang=js&"
export * from "./JobsTemplateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./JobsTemplateDashboard.vue?vue&type=style&index=0&id=3b984005&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b984005",
  null
  
)

export default component.exports